import { render, staticRenderFns } from "./settlegrowers.vue?vue&type=template&id=d427ff38"
import script from "./settlegrowers.vue?vue&type=script&lang=js"
export * from "./settlegrowers.vue?vue&type=script&lang=js"
import style0 from "./settlegrowers.vue?vue&type=style&index=0&id=d427ff38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports